<h2 class="mt-[100px] font-semibold opacity-50 text-center" i18n="@@no_data_to_show">No Data To Show</h2>